import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';

import amplitude from 'amplitude-js';
import { setNewForm } from 'apps/auth/actions/formAction';
import { Button } from 'apps/auth/components/common/Button/Button';
import { CommonPage } from 'apps/auth/components/common/Layout/CommonPage/CommonPage';
import { FixedBottomPanel } from 'apps/auth/components/common/Layout/FixedBottomPanel/FixedBottomPanel';
import { HeaderPanel } from 'apps/auth/components/common/Layout/HeaderPanel/HeaderPanel';
import { Text } from 'apps/auth/components/common/Text/Text';
import Form from 'apps/auth/components/form-multi/Form';
import InputAmount from 'apps/auth/components/form-multi/InputAmount';
import { HintContainer } from 'apps/auth/components/form-multi/styles';
import { getField } from 'apps/auth/components/form-multi/utils';
import { CARD_VERIFICATION_COMPLETED, CARD_VERIFICATION_CONTINUE_CLICKED } from 'apps/auth/constants/amplitude/AmplitudeEvents';
import { VALID_ERROR, XSS_FILTER_OPTIONS } from 'apps/auth/constants/Constants';
import { CONFIRM_CARD_BY_AMOUNT } from 'apps/auth/constants/formName';
import { AUTH_SEND_MAIN_LINK } from 'apps/auth/constants/UrlConstants';
import { addZero, resolveArguments } from 'apps/auth/helpers/utils';
import { filterXSS } from 'xss';

import ConfirmAmountCurrency from './ConfirmAmountCurrency';

const ConfirmAmount = (props) => {
    const [fields, setFields] = useState(props.form ? props.form.fields : null);

    useEffect(() => {
        if (!fields) {
            const fields = {};
            fields.code = getField('code', '', '^\\d{1,2}(\\.\\d{0,2})?$', true, false, props.amountPlaceholder, 'tel');
            fields.objectId = getField('objectId', props.sms_confirm?.objectId, null, true);
            fields.objectType = getField('objectType', props.sms_confirm?.objectType, null, true);
            fields.expired = getField('expired', getDate(props.sms_confirm?.expired), null, true);
            props.setNewForm(CONFIRM_CARD_BY_AMOUNT, fields, `/auth/card/${props.sms_confirm?.objectId}/confirm.action`).then(() => setFields(fields));
        }
    }, []);

    const getDate = (date) => {
        let actualDate = new Date(date);
        actualDate.setDate(actualDate.getDate() + 1);
        return `${actualDate?.getFullYear()}-${addZero(actualDate?.getMonth() + 1)}-${addZero(actualDate?.getDate())}Z`;
    };

    const subtitleFiltered = (props) => {
        return resolveArguments(props.notice, [props.confirm_amount?.amountTo, props.confirm_amount?.recipientInfo, props.confirm_amount?.accountFrom]);
    };

    const submitHandler = (fields, json) => {
        if (json?.extra?.confirm_url) {
            amplitude.getInstance().logEvent(CARD_VERIFICATION_COMPLETED);
            window.location.href = json.extra.confirm_url;
        }
    };

    return (
        <CommonPage backUrl={AUTH_SEND_MAIN_LINK} leftCloseIcon>
            <HeaderPanel title={props.amountHeader} subtitle={filterXSS(subtitleFiltered(props), XSS_FILTER_OPTIONS)} />
            {fields && (
                <Form
                    id="sms_confirm_form_id"
                    action={`/auth/card/${props.sms_confirm?.objectId}/confirm.action`}
                    formName={CONFIRM_CARD_BY_AMOUNT}
                    onSubmitHandler={submitHandler}
                    fields={props.form.fields}
                >
                    <InputAmount formName={CONFIRM_CARD_BY_AMOUNT} field={props.form.fields.code} isNewInput>
                        <ConfirmAmountCurrency
                            currencyIcon={props.confirm_amount?.curCodeFrom.toLowerCase()}
                            currencyCode={props.confirm_amount?.curCodeFrom}
                        />
                    </InputAmount>
                    {props.form.fields.code.isError && (
                        <HintContainer>
                            <Text variant="div" color="error" size="secondary">
                                {props.form.fields.code.errorMessage ? props.form.fields.code.errorMessage : props.messages[VALID_ERROR]}
                            </Text>
                        </HintContainer>
                    )}
                    <FixedBottomPanel>
                        <Button
                            type="submit"
                            raised={true}
                            caption={props.confirmButtonMessage}
                            onClick={() => {
                                amplitude.getInstance().logEvent(CARD_VERIFICATION_CONTINUE_CLICKED);
                            }}
                        />
                    </FixedBottomPanel>
                </Form>
            )}
        </CommonPage>
    );
};
const mapStateToProps = (state) => {
    return {
        form: state.form[CONFIRM_CARD_BY_AMOUNT],
        amountHeader: state.messages.pageMessages.amountHeader,
        amountPlaceholder: state.messages.pageMessages.amountPlaceholder,
        notice: state.messages.pageMessages.notice,
        confirmButtonMessage: state.messages.pageMessages.confirmButtonMessage,
        confirm_amount: state.extra.confirm_amount,
        sms_confirm: state.extra.sms_confirm,
        messages: state.messages.jsMessages,
    };
};
export default connect(mapStateToProps, { setNewForm })(ConfirmAmount);
